import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorCatchService } from './error-catch.service';
import { MessagesService } from './messages.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private errorCatchService: ErrorCatchService, private _router: Router, private messagesService:MessagesService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((error: any, caught: Observable<any>) => {
        if (error.error?.token && error.error?.token == 'vencido') {
          this.messagesService.tokenVencido('Debes volver a iniciar sesión','Has estado inactivo por varios minutos','info').then((result) => {
            if (result.isConfirmed) {
              localStorage.removeItem('token');
              this._router.navigate(['/login']);
            }
          })
          return of(); // Return an empty observable
        } else if (error.error.token) {
          localStorage.setItem('token', error.error?.token);
        }
        
        this.errorCatchService.setError(`Error ${error.status}: ${error.message}`);
        return throwError(error);
      })
    );
  }
}


